class FooterController {
	constructor($state, Category) {
		this.name = 'footer'

		this.$state = $state
		this.Category = Category
	}

	clearCategories() {
		this.Category.clearSelectedCategories()

		this.$state.go('home', { search: '' })
	}
}

FooterController.$inject = ['$state', 'Category']

export default FooterController



// WEBPACK FOOTER //
// ./client/app/common/footer/footer.controller.js